import { defineAsyncComponent } from 'vue'

export async function getAsyncComponent(view: string) {
  return defineAsyncComponent(() => getComponent(view))
}
export async function getComponent(view: string) {
  const comps = import.meta.glob('../**/*.vue')
  const route = `../${view}`
  let match: () => Promise<any> = comps[route]
  if (!match) {
    console.error(new Error(`Component not found: ${route}`))
    match = comps[`../components/errors/404.vue`]
  }
  return (await match()).default
}
